export default __webpack_public_path__ + "static/media/legal-ip.58237900.svg";